import { useState } from "react";
import ThreeViewer from "../../components/sample3d/ThreeViewer";
import Info from "../../components/sample3d/Info";
import ViewerToolbar from "../../components/sample3d/ViewerToolbar";
import "./sample3d.css";

export default function SampleThreeDPage() {
  const [isMouseOption, setIsMouseOption] = useState("pointer");
  const [isCameraReset, setIsCameraReset] = useState("");
  const [isPlay, setIsPlay] = useState(false);
  const [frequneyRange, setFrequencyRange] = useState("gas");
  const [analysis, setAnalysis] = useState(null);
  const [values, setValues] = useState({ avgdB: "", peakdB: "", peakHz: "" });
  const [clickSpectrum, setClickSpectrum] = useState(null);
  const [distance, setDistance] = useState(1); // m 단위 표시값
  const [isNearHotspot, setIsNearHotspot] = useState(false);

  const audioUrls = {
    tl: `/wav/${frequneyRange}_left.wav`,
    bl: `/wav/${frequneyRange}_left.wav`,
    tr: `/wav/${frequneyRange}_right.wav`,
    br: `/wav/${frequneyRange}_right.wav`,
    hotspot: `/wav/${frequneyRange}_hotspot.wav`,
  };

  return (
    <section className="content sample-studio">
      <div className="sample-page-heading">
        <div><h2>3D 음향 워크스페이스</h2></div>
      </div>
      <div className="sample-workspace">
        <div className="sample-world">
          <ThreeViewer
            plyUrl="/assets/sample.ply"
            textureUrl="/assets/sample.png"
            mouseMode={isMouseOption}
            isCameraReset={isCameraReset}
            setIsCameraReset={setIsCameraReset}
            isPlay={isPlay}
            onAnalysisReady={setAnalysis}
            onClickSpectrum={setClickSpectrum}
            onDistanceChange={setDistance} // 실시간 메시랑 카메라사이 거리 0.3 ~ 3
            // 🔊 카메라-코너 배경음 설정
            setIsNearHotspot={setIsNearHotspot}
            ambience={{
              distance: 3, // 카메라로부터 코너까지 거리
              urls: audioUrls, // 코너별 파일

              gains: { tl: 0.1, tr: 0.1, bl: 0.1, br: 0.1, hotspot: 1.5 }, // 기본 볼륨
              autoplay: isPlay, // 사용자 토글로 재생 시작(첫 제스처 필요)
              hotspot: {
                pos: [7.5, 3, 0],
                distanceModel: "exponential", // 급격 감쇠
                refDistance: 5, // 20cm 정도 기준 거리
                maxDistance: 0.5, // 1m 이상 멀어지면 거의 무음
                rolloff: 2.0, // 감쇠 속도 크게
              },
              // 아래 3개는 선택(줌아웃 시 점점 작아지게 하고 싶다면)
            }}
          />
          <ViewerToolbar mode={isMouseOption} onModeChange={setIsMouseOption} onReset={() => setIsCameraReset("reset")} playing={isPlay} onPlay={() => setIsPlay((value) => !value)} band={frequneyRange} onBandChange={setFrequencyRange} />
        </div>
        <Info
          values={values}
          setValues={setValues}
          isMouseOption={isMouseOption}
          setIsMouseOption={setIsMouseOption}
          isCameraReset={isCameraReset}
          setIsCameraReset={setIsCameraReset}
          isPlay={isPlay}
          setIsPlay={setIsPlay}
          frequneyRange={frequneyRange}
          setFrequencyRange={setFrequencyRange}
          analysis={analysis}
          clickSpectrum={clickSpectrum}
          distance={distance}
          isNearHotspot={isNearHotspot}
        />
      </div>
    </section>
  );
}
